import {UIGameManager} from '../UIGameManager'
import {UIShipHoverActionController} from '../ui_game_hover_actions/UIShipHoverActionController'
import {UIMoveShipHoverActionController} from '../ui_game_hover_actions/UIMoveShipHoverActionController'
import {MechanicPirateState, MechanicShipState} from '@colonist/game-states'

export class UIGameMapShipController {
    private readonly uiGameManager: UIGameManager

    constructor(uiGameManager: UIGameManager, shipState: MechanicShipState, mechanicPirateState: MechanicPirateState | undefined) {
        this.uiGameManager = uiGameManager

        if(this.uiGameManager.gameController.isReplay) return
        this.initializeHoverActions(shipState, mechanicPirateState)
    }

    private initializeHoverActions(shipState: MechanicShipState, mechanicPirateState: MechanicPirateState | undefined) {
        new UIShipHoverActionController(this.uiGameManager, shipState, mechanicPirateState)
        new UIMoveShipHoverActionController(this.uiGameManager, shipState, mechanicPirateState)
    }
}
